import type { StoredGroup } from '~/gql/groups/groups'
import { useMutation } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { Button } from '~/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/components/ui/dialog'
import { GQL_DELETE_GROUP } from '~/gql/groups/groups'

type IProps = {
  open: boolean
  onCancel: () => void
  onSuccess: () => void | Promise<unknown>
  group: StoredGroup
}

function GroupDeleteModal({ open, onCancel, onSuccess, group }: IProps) {
  const { t } = useTranslation()

  const [deleteGroup] = useMutation(GQL_DELETE_GROUP)

  const handleDelete = async () => {
    try {
      await deleteGroup({ variables: { id: group.id } })
      toast.success(t('groups.deleted'))
      await onSuccess()
    } catch {
      toast.error(t('groups.deleteFailed'))
    }
    onCancel()
  }

  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('groups.delete.title')}</DialogTitle>
          {/*
            Rassurer explicitement : supprimer un groupe défait un regroupement,
            il ne supprime aucun compte. Sans cette phrase, l'admin hésite.
          */}
          <DialogDescription>
            {t('groups.delete.message', { name: group.name, count: group.memberCount })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>{t('common.cancel')}</Button>
          <Button variant="destructive" onClick={handleDelete}>{t('common.delete')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default GroupDeleteModal
